import i18n from "i18next";
import { useEffect } from "react";

// Minimal SEO component without external deps.
export default function SEO({
  title,
  description,
  url = typeof window !== "undefined" ? window.location.href : "",
  image = "/logo.png",
  lang,
  noindex = false,
  siteName = "TutorMesh 課聯",
}) {
  // Determine language-aware defaults
  const currentLang = (lang || i18n.language || "en").toLowerCase();
  console.log("Current language:", currentLang);
  const isZh = currentLang.startsWith("zh");
  const defaults = isZh
    ? {
        title: "免費私人補習配對平台",
        description:
          "TutorMesh 課聯是完全免費的導師宣傳平台，幫助家長尋找合適導師，同時協助導師找到學生。平台不收取任何中介費用，導師與家長直接聯繫，達成最適合的教學協議。",
        lang: "zh-TW",
      }
    : {
        title: "Free Private Tutoring Matching Platform",
        description:
          "TutorMesh is a completely free tutor promotion platform that helps parents find suitable tutors while assisting tutors in finding students. The platform charges no intermediary fees, allowing direct communication between tutors and parents to reach the most suitable teaching agreement.",
        lang: "en",
      };

  const finalTitle = title ?? defaults.title;
  const finalDescription = description ?? defaults.description;
  const finalLang = lang ?? defaults.lang;
  useEffect(() => {
    if (typeof document === "undefined") return;
    const fullTitle = finalTitle ? `${finalTitle} | ${siteName}` : siteName;
    document.title = fullTitle;
    document.documentElement.lang = finalLang;

    const upsert = (attrName, attrValue, content) => {
      if (!content && content !== "") return null;
      const selector = `meta[${attrName}='${attrValue}']`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attrName, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
      return el;
    };

    const metas = [
      ["name", "description", finalDescription],
      ["name", "robots", noindex ? "noindex, nofollow" : "index, follow"],
      ["property", "og:type", "website"],
      ["property", "og:site_name", siteName],
      ["property", "og:title", fullTitle],
      ["property", "og:description", finalDescription],
      ["property", "og:url", url],
      ["property", "og:image", image],
      ["name", "twitter:card", "summary_large_image"],
      ["name", "twitter:title", fullTitle],
      ["name", "twitter:description", finalDescription],
      ["name", "twitter:image", image],
    ];

    metas.forEach(([a, v, c]) => upsert(a, v, c));

    return () => {
      // leave meta tags in place to avoid flicker; cleanup logic could go here if desired
    };
  }, [finalTitle, finalDescription, url, image, finalLang, noindex, siteName]);

  return null;
}
